<template>
  <v-container fluid>
    <div class="wineItemComponentForm">
      <v-form ref="form" v-model="valid" lazy-validation>
        <!--<v-layout row wrap>-->
        <!--<v-flex xs8>-->
        <!--<v-text-field-->
        <!--v-model="ID"-->
        <!--label="ID" readonly-->
        <!--&gt;</v-text-field>-->
        <!--</v-flex>-->
        <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->
          <div class="VineYear__Content">
            <v-layout row wrap>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="alkohol"
                    label="Alkohol (% vol.)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="slobodni_sulfati"
                    label="Slobodni SO2 (g/hl)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="ukupni_sulfati"
                    label="Ukupni SO2 (g/hl)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                
              </v-layout>
              <!-- /.Tank -->

              <v-layout row wrap>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="rezidualni_secer"
                    label="Rezidualni šećer (g/l)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="kiselina"
                    label="Ukupno kiselina (g/l)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 pa-2>
                  <v-text-field
                    v-model="ph"
                    label="PH vrednost"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <!-- /.Tank -->

            <div class="TankDetails">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea :key="autoGrowHack" v-model="opis" label="Opis" auto-grow rows="7"></v-textarea>
                </v-flex>
              </v-layout>
              
            </div>
          </div>

        <!-- /.Tank -->

        <v-layout row wrap>
          <v-flex xs12>
            <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
              >Sačuvaj</v-btn
            >
            <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
          </v-flex>
        </v-layout>
        <!-- /.Action buttons -->
      </v-form>
      <TokenComponent ref="frmtoken" />
    </div>
  </v-container>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  props: ["item"],
  name: "WineItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    autoGrowHack:false,
    valid: true,
    ID: "0",
    godina: 0,
    alkohol: undefined,
    rezidualni_secer: undefined,
    kiselina: undefined,
    ph: undefined,
    wt_items: [],
    select: "",
    opis: "",
    slobodni_sulfati: undefined,
    totalSulfates: undefined,
    ukupni_sulfati: undefined
  }),
  watch: {
    item: function (val) {
      if (val !== undefined) {
        console.log(val);

        this.ID = val.id;
        this.opis = val.description;
        this.alkohol = val.alcohol;
        this.rezidualni_secer = val.residualSugar;
        this.slobodni_sulfati = val.freeSulfates;
        this.ph = val.ph;
        this.kiselina = val.totalAcid;
        this.godina = val.year;

        this.ukupni_sulfati = val.totalSulfates;
        this.select = val.wineLabel;
      }
    },
  },
  methods: {
    getFieldText(item) {
      let response = "";
      

      if(item !== undefined)
        response = `${item.name} - ${item.wineType.name}`;

      return response;
    },
    changeSifarnik() {
      var complexObjectWineLabel = {
        id: this.select.id,
      };

      var complexObject = {
        id: this.ID,
        year: this.godina,
        alcohol: this.alkohol,
        residualSugar: this.rezidualni_secer,
        totalAcid: this.kiselina,
        ph: this.ph,
        wineLabel: complexObjectWineLabel,
        description: this.opis,
        freeSulfates: this.slobodni_sulfati,
        totalSulfates: this.ukupni_sulfati,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.$emit("newdata", null);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.$emit("newdata", null);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllEtikete() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })

        .then((response) => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) this.changeSifarnik();
    },
    clear() {
      var d = new Date();
      this.godina = d.getFullYear();

      this.opis = undefined;

      this.ph = undefined;
      this.slobodni_sulfati = undefined;
      this.rezidualni_secer = undefined;
      this.alkohol = undefined;
      this.kiselina = undefined;
      this.ukupni_sulfati = undefined;

      this.$emit("close", null);
    }
  },
  mounted() {
    this.clear();
    var d = new Date();
    this.godina = d.getFullYear();

    this.getAllEtikete();

    serverBus.$on("applied_wine", (item) => {
      this.ID = item.id;
      this.godina = item.year;
      this.alkohol = item.alcohol;

      this.rezidualni_secer = item.residualSugar;
      this.kiselina = item.totalAcid;

      this.ph = item.ph;
      this.opis = item.description;

      this.slobodni_sulfati = item.freeSulfates;

      this.ukupni_sulfati = item.totalSulfates;

      if (item.wineLabel !== null) {
        this.select = item.wineLabel;
      } else {
        this.select = "";
      }
    });
  },
};
</script>
    
<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";

.VineYear {
  margin-top: 0px;
  margin-bottom: 80px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      font-family: NunitoSans, sans-serif;
      font-size: 32px;
      letter-spacing: 0;
      font-weight: 300;
      // text-transform: uppercase;
      color: #000;
    }
    .more_info {
      color: #fff;
      border: solid 1px;
      margin-top: 6px;
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    &__Vine {
      display: flex;
      // margin-right: 30px;
      .VineBox {
        margin-right: 15px;
      }
      .VineYears {
        max-width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px -3px -3px -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: solid 1px #9b9b9b;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0;
          text-align: center;
          color: #000000;
        }
      }
    }
  }
}

.Description textarea {
  height: 40px;
}
div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.TankDetails {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 100%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 130px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 10px;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      width: 50%;
      color: #000;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
    .kvaka {
      max-width: 45px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}
</style>
